import { useState } from "react";
import { PackageX, X } from "lucide-react";

// A parcel taken off this Rider in the last few hours, and why. Reassignment
// used to make work vanish from the Rider's screen - possibly while they were
// driving to the store - with no reason given. Dismissing is per device and
// only hides the notice; nothing here changes the reassignment.
const REASONS = {
  SHIPMENT_INVALID: "the store changed the parcel (for example, reprinted its label)",
  MISSED_PICKUP_BY: "the pickup time limit passed",
  MEMBERSHIP_REVOKED: "you are no longer a member of the store",
  CAPABILITY_REVOKED: "you can no longer take deliveries for the store",
  EMPLOYMENT_ENDED: "you no longer work for the store",
  EMERGENCY_CONFIRMED: "the store confirmed your emergency report",
  VEHICLE_INOPERABLE_CONFIRMED: "the store confirmed your vehicle problem",
  CONFIRM_EMERGENCY_AND_REASSIGN: "the store confirmed your emergency report",
  CONFIRM_VEHICLE_AND_REASSIGN: "the store confirmed your vehicle problem",
  REASSIGN: "the store reassigned it",
};

const storageKey = "apparify:rider-dismissed-withdrawals";
function readDismissed() {
  try { return new Set(JSON.parse(window.localStorage.getItem(storageKey) || "[]")); } catch { return new Set(); }
}

export default function RiderWithdrawalNotice({ withdrawals = [], className = "" }) {
  const [dismissed, setDismissed] = useState(readDismissed);
  const visible = (withdrawals || []).filter((item) => !dismissed.has(item.assignmentId));
  if (!visible.length) return null;

  const dismiss = (assignmentId) => {
    const next = new Set(dismissed).add(assignmentId);
    setDismissed(next);
    try { window.localStorage.setItem(storageKey, JSON.stringify([...next].slice(-50))); } catch { /* storage unavailable */ }
  };

  return (
    <div className={`space-y-2 ${className}`} data-testid="rider-withdrawal-notice">
      {visible.map((item) => (
        <div
          key={item.assignmentId}
          role="status"
          className="flex items-start gap-3 rounded-xl border border-amber-300 bg-amber-50 p-3 dark:border-amber-500/40 dark:bg-amber-500/10"
        >
          <PackageX className="mt-0.5 h-4 w-4 shrink-0 text-amber-900 dark:text-amber-200" aria-hidden="true" />
          <div className="min-w-0 flex-1 text-sm text-amber-900 dark:text-amber-200">
            <p className="font-semibold">Pickup cancelled: {item.orderReference}</p>
            <p className="mt-1 text-amber-900/90 dark:text-amber-200/90">
              You were taken off this parcel because {REASONS[item.reasonCode] || "the store reassigned it"}. Do not collect it.
            </p>
          </div>
          <button
            type="button"
            onClick={() => dismiss(item.assignmentId)}
            aria-label={`Dismiss notice for ${item.orderReference}`}
            className="grid h-9 w-9 shrink-0 place-items-center rounded-lg text-amber-900 hover:bg-amber-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 dark:text-amber-200 dark:hover:bg-amber-500/20"
          >
            <X className="h-4 w-4" aria-hidden="true" />
          </button>
        </div>
      ))}
    </div>
  );
}
